import {
  dialogFlowIntentNamesLowerCaseKeys,
  goodDialogFromIntents
} from 'features/Engagement/constants'
import GraphIcon from 'features/Engagement/GraphIcon'
import { useEffect, useState } from 'react'
import engagementApi from 'services/api/engagement'

import styles from './MessagesByTopic.module.scss'

const MessagesByTopic = ({ onOpenDetails, startDate, endDate, hotelIds }) => {
  const [topicData, setTopicData] = useState()
  const [topicDataStatus, setTopicDataStatus] = useState('pending')
  const [topicDataError, setTopicDataError] = useState()

  useEffect(() => {
    const abortController = new AbortController()

    setTopicDataStatus('pending')

    engagementApi
      .topics(
        {
          subsidiaryIds: hotelIds,
          fromDate: startDate?.format('YYYY-MM-DD'),
          toDate: endDate?.format('YYYY-MM-DD')
        },
        abortController
      )
      .then(data => {
        setTopicData(data)
        setTopicDataStatus('fetched')
      })
      .catch(err => {
        if (!err.toString().includes('The user aborted a request.')) {
          setTopicDataStatus('rejected')
          setTopicDataError(err)
        }
      })

    return () => abortController.abort()
  }, [hotelIds, startDate, endDate])

  if (topicDataStatus === 'pending') {
    return <div className={styles.wrapper}></div>
  }

  if (topicDataStatus === 'rejected') {
    return (
      <div className={styles.wrapper}>
        Failed to get data: {topicDataError?.toString()}
      </div>
    )
  }

  const filteredTopicKeys = Object.keys(topicData)
    .sort((a, b) => topicData[b].topicCount - topicData[a].topicCount)
    .filter(k =>
      goodDialogFromIntents.some(goodIntent => goodIntent.toLocaleLowerCase() === k)
    )

  const totalTopics = filteredTopicKeys.reduce(
    (prev, curr) => topicData[curr].topicCount + prev,
    0
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h3 className={styles.title}>Messages by topic</h3>
        <button className={styles.detailsLink} onClick={onOpenDetails}>
          <GraphIcon width={24} height={24} style={{ marginRight: 8, marginLeft: -4 }} />
          View change over time
        </button>
      </div>
      <table className={styles.table}>
        <tr>
          <th>Topic</th>
          <th>Messages</th>
          <th>Percentage</th>
        </tr>
        {filteredTopicKeys.map(k => (
          <tr key={k}>
            <td>{dialogFlowIntentNamesLowerCaseKeys[topicData[k].topic]}</td>
            <td>{topicData[k].topicCount}</td>
            <td>{Math.round((100 * topicData[k].topicCount) / totalTopics)}%</td>
          </tr>
        ))}
      </table>
    </div>
  )
}

export default MessagesByTopic
